import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import {useDispatch} from 'react-redux';
import actions from 'features/layout/redux/actions';
import api from 'api';
import React from 'react';
import {useDeleteApi} from 'common/hooks/useDeleteApi';
import {unpackId} from 'common/diplomatIdUtil';
import {usePartnersRefs} from 'redux/partners/hooks/usePartnersRefs';
import {useTransactionsRefs} from 'redux/transactions/hooks/useTransactionsRefs';
import DeleteKeyDialog from 'features/layout/DialogRoutes/dialogs/keys/DeleteKeyDialog';
import {DialogTypes} from 'common/names';
import {useModal} from 'common/hooks/useModal';
import {DiplomatObjectType} from 'types/DiplomatObjectType';
import {usePostApi} from 'common/hooks/usePostApi';
import {useSynchronizationsRefs} from 'redux/synchronizations/hooks/useSynchronizationsRefs';
import {useSftpsRefs} from 'redux/sftp-user/hooks/useSftpsRefs';

type DeleteSSHKeyPairDialogProps = {
   data: INav;
   onClose: () => void;
};

const DeleteSSHKeyPairDialog = ({data, onClose}: DeleteSSHKeyPairDialogProps) => {
   const {open, handleOpen, handleClose} = useModal();
   const dispatch = useDispatch();
   const {id} = unpackId(data.id);
   const partners = usePartnersRefs(id, 'ssh');
   const transactions = useTransactionsRefs(id, 'ssh');
   const synchronizations = useSynchronizationsRefs(id, 'ssh');
   const sftpServers = useSftpsRefs(id, 'ssh');
   const isPublicKey = data.objectType === DiplomatObjectType.enum.SSH_PUBLIC_KEY;

   const onSuccess = () => {
      dispatch(actions.loadTreeNav());
      onClose();
   };
   const onFailure = (error: string, message: string) => {
      if (message?.includes('Passphrase is invalid')) {
         handleOpen();
      }
   };
   const {request} = useDeleteApi(api.sshKeys + `/${id}`, {
      onSuccess,
   });
   const {request: clearKeyRequest} = usePostApi(`${api.sshKeyClear}`, {
      onSuccess,
   });

   const handleConfirm = (values?: {passphrase: string; force: boolean}) => {
      if (values?.force) {
         handleClose();
      }
      request({searchParams: values, onFailure});
   };

   const handleClear = () => {
      clearKeyRequest(
         JSON.stringify({
            existingKeyId: id,
         })
      );
   };

   return (
      <DeleteKeyDialog
         dialogTitle={DialogTypes.DeleteSSHKeyPairDialog.dialogName}
         data={data}
         partners={partners}
         transactions={transactions}
         synchronizations={synchronizations}
         sftpServers={sftpServers}
         requirePassphrase={!isPublicKey}
         forceDeletionPrompt={open}
         onConfirm={handleConfirm}
         onClose={onClose}
         onClear={handleClear}
      />
   );
};

export default DeleteSSHKeyPairDialog;
